import React, {useState} from 'react';
import {
    Card,
    CardActionArea,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from '@mui/material';
import {MdBusiness, MdClose, MdGavel, MdGroups, MdHowToReg, MdLanguage, MdPerson} from 'react-icons/md';
import EditInputFields from "./EditInputFields";

const entityOptions = [
    {key: 'physical', label: 'ფიზიკური პირი', icon: <MdPerson size={48} color="#3872F2"/>},
    {key: 'legal', label: 'კერძო სამართლის იურიდიული პირი', icon: <MdBusiness size={48} color="#3872F2"/>},
    {key: 'association', label: 'საჯარო სამართლის იურიდიული პირი', icon: <MdGavel size={48} color="#3872F2"/>},
    {key: 'association', label: 'ამხანაგობა და სხვა', icon: <MdGroups size={48} color="#3872F2"/>},
    {key: 'foreigner', label: 'უცხო ქვეყნის მოქალაქე', icon: <MdLanguage size={48} color="#3872F2"/>},
];

const EditObjectOwnerPopup = ({open, onClose, caseDetails, onSave,  isExp}) => {
    const [selectedEntity, setSelectedEntity] = useState(null)
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false)




    const handleSelect = (key) => {
        setSelectedEntity(key)
        setIsEditPopupOpen(true)
    };


    const closePopup = (shouldCloseMainPopup = false) => {
        if (shouldCloseMainPopup) {
            setIsEditPopupOpen(false)
        }
        onClose()
    }

    return (
        <>
            <EditInputFields isExp={isExp} open={isEditPopupOpen} onClose={closePopup} entity={selectedEntity}
                             caseDetails={caseDetails} onSave={onSave}/>
            <Dialog open={open} onClose={() => {
                onClose();
            }} maxWidth="sm" fullWidth>
                <DialogTitle sx={{m: 0, p: 2}}>
                    <IconButton
                        onClick={() => {
                            onClose();
                        }}
                        sx={{position: 'absolute', right: 12, top: 0, color: '#999'}}
                    >
                        <MdClose/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>


                    <Grid container spacing={3} justifyContent="center">
                        {entityOptions.map(({key, label, icon}) => (
                            <Grid key={key} item xs={12} sm={6}>
                                <Card
                                    elevation={4}
                                    sx={{
                                        height: 180,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 4,
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        '&:hover': {transform: 'scale(1.05)', boxShadow: 6}
                                    }}
                                >
                                    <CardActionArea
                                        onClick={() => handleSelect(key)}
                                        sx={{
                                            height: '100%',
                                            p: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 1
                                        }}
                                    >
                                        {icon}
                                        <Typography variant="h6" fontWeight={500} textAlign="center">
                                            {label}
                                        </Typography>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
};

export default EditObjectOwnerPopup;
